import commons from './commons'
import brands from './brands'
import hotmart from './hotmart'

export default {
  ...commons,
  ...brands,
  ...hotmart,
}
